import EventGuest from "./guest";
import EventOrganiser from "./organiser";

const LoggedInUserContent = ({ eventUserRole, eventUserData, branding }) => {
  return (
    <div>
      <div>
        {eventUserRole === "2" && (
          <EventOrganiser eventUserData={eventUserData} branding={branding} />
        )}
      </div>
      <div>
        {eventUserRole === "1" && (
          <EventGuest eventUserData={eventUserData} branding={branding} />
        )}
      </div>
    </div>
  );
};

export default LoggedInUserContent;
